module.exports = __webpack_public_path__ + "img/pc_safe_icon.ac075541.png";